export default "__VITE_ASSET__mwzoRATq__"